import { useIsMobile } from "src/hooks/useIsMobile";

const GoalGraph = () => {
  const isMobile = useIsMobile();
  return !isMobile ? (
    <svg
      width="366"
      height="188"
      viewBox="0 0 366 188"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="47.9717"
        y1="162"
        x2="47.9717"
        y2="36"
        stroke="url(#paint0_linear_3587_34049)"
        strokeDasharray="3 3"
      />
      <line
        x1="316.33"
        y1="162"
        x2="316.33"
        y2="135"
        stroke="url(#paint1_linear_3587_34049)"
        strokeDasharray="3 3"
      />
      <g filter="url(#filter0_d_3587_34049)">
        <circle cx="47.0005" cy="45" r="15" fill="#15202B" />
      </g>
      <g filter="url(#filter1_d_3587_34049)">
        <circle cx="315" cy="135" r="15" fill="#15202B" />
      </g>
      <path
        d="M47.701 44.9988C47.701 44.9988 96.6273 41.1246 127.481 56.3499C154.119 69.495 187.278 97.9988 187.278 97.9988C238.623 133.757 238.944 135.499 316.831 135.499"
        stroke="#15202B"
      />
      <defs>
        <filter
          id="filter0_d_3587_34049"
          x="0.000488281"
          y="0"
          width="98"
          height="98"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_3587_34049"
          />
          <feOffset dx="2" dy="4" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.396078 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3587_34049"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3587_34049"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3587_34049"
          x="268"
          y="90"
          width="98"
          height="98"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_3587_34049"
          />
          <feOffset dx="2" dy="4" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.396078 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3587_34049"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3587_34049"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3587_34049"
          x1="48.9717"
          y1="36"
          x2="48.9717"
          y2="162"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005765" />
          <stop offset="1" stopColor="#005765" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3587_34049"
          x1="317.33"
          y1="135"
          x2="317.33"
          y2="162"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005765" />
          <stop offset="1" stopColor="#005765" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="274"
      height="182"
      viewBox="0 0 274 182"
      fill="none"
    >
      <line
        x1="43.5"
        y1="159"
        x2="43.5"
        y2="33"
        stroke="url(#paint0_linear_3565_35047)"
        strokeDasharray="3 3"
      />
      <line
        x1="227.351"
        y1="159"
        x2="227.351"
        y2="132"
        stroke="url(#paint1_linear_3565_35047)"
        strokeDasharray="3 3"
      />
      <g filter="url(#filter0_d_3565_35047)">
        <circle cx="42.999" cy="41" r="11" fill="#15202B" />
      </g>
      <g filter="url(#filter1_d_3565_35047)">
        <circle cx="227" cy="133" r="11" fill="#15202B" />
      </g>
      <path
        d="M43.4726 41.9988C43.4726 41.9988 76.9914 38.1246 98.1287 53.3499C116.378 66.495 139.096 94.9988 139.096 94.9988C174.271 130.757 174.491 132.499 227.85 132.499"
        stroke="#15202B"
      />
      <defs>
        <filter
          id="filter0_d_3565_35047"
          x="-0.000976562"
          y="0"
          width="90"
          height="90"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_3565_35047"
          />
          <feOffset dx="2" dy="4" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.396078 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3565_35047"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3565_35047"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3565_35047"
          x="184"
          y="92"
          width="90"
          height="90"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_3565_35047"
          />
          <feOffset dx="2" dy="4" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.341176 0 0 0 0 0.396078 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3565_35047"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3565_35047"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3565_35047"
          x1="44.5"
          y1="33"
          x2="44.5"
          y2="159"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005765" />
          <stop offset="1" stopColor="#005765" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3565_35047"
          x1="228.351"
          y1="132"
          x2="228.351"
          y2="159"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005765" />
          <stop offset="1" stopColor="#005765" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GoalGraph;
